import { Link, NavLink, Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "./AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", end: true },
  { to: "/admin/content", label: "Content" },
  { to: "/admin/blog", label: "Blog" },
  { to: "/admin/showcase", label: "Showcase" },
  { to: "/admin/settings", label: "Settings" },
  { to: "/admin/seo", label: "SEO" },
  { to: "/admin/media", label: "Media" },
  { to: "/admin/scripts", label: "Scripts" },
  { to: "/admin/transactional", label: "Transactional" },
  { to: "/admin/backups", label: "Backups" },
  { to: "/admin/sync", label: "Push to Live" },
];

export default function AdminLayout() {
  const auth = useAdminAuth();
  const location = useLocation();
  if (auth.user === null) {
    return (
      <div className="min-h-screen bg-[#0B0F14] text-neutral-400 flex items-center justify-center">
        <span className="text-[0.7rem] font-bold tracking-[0.3em] uppercase">Loading…</span>
      </div>
    );
  }
  if (auth.user === false) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return (
    <div className="min-h-screen bg-[#0B0F14] text-neutral-100 flex">
      <aside className="w-64 shrink-0 bg-[#0F141A] border-r border-white/[0.06] flex flex-col">
        <div className="px-6 pt-7 pb-6 border-b border-white/[0.06]">
          <Link to="/" className="block">
            <div className="text-[0.62rem] font-bold tracking-[0.3em] uppercase text-[#F4D64E]">
              Sunday · Admin
            </div>
            <div className="mt-1 font-display text-lg font-black tracking-[-0.015em]">
              CMS
            </div>
          </Link>
        </div>
        <nav className="flex-1 px-3 py-5 flex flex-col gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `px-4 py-2.5 rounded-md text-[0.78rem] font-bold tracking-[0.05em] transition-colors ${
                  isActive
                    ? "bg-[#F4D64E]/10 text-[#F4D64E]"
                    : "text-neutral-400 hover:text-white hover:bg-white/[0.04]"
                }`
              }
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="px-6 py-5 border-t border-white/[0.06] text-[0.7rem] text-neutral-500">
          <div className="truncate text-neutral-300 font-bold">{auth.user?.email}</div>
          <div className="text-[0.6rem] tracking-[0.2em] uppercase mt-1">{auth.user?.role}</div>
          <button
            type="button"
            onClick={auth.logout}
            data-testid="admin-logout"
            className="mt-3 inline-flex items-center gap-1 text-[0.65rem] font-bold tracking-[0.2em] uppercase text-neutral-400 hover:text-[#F4D64E] transition-colors"
          >
            ← Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0 overflow-y-auto">
        <div className="max-w-6xl mx-auto px-10 py-10">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
